const theme = {};

theme.palette = {
    primary: {main: '#049fbd'},
    secondary: {main: '#d82a52'},
    gray: {main: '#62717f'},
    darkGray: {main: '#212529'},
    radio: {main: '#17749C'},
    fliperama: {main: '#005072'},
};

theme.typography = {
    useNextVariants: true,
    fontFamily: [
        "Univers",
        'Arial',
        'sans-serif',
      ].join(','),
}

theme.assets = {}

theme.sizes = {
    baseSize: 25,
}


export default theme;